import { Stack, TablePagination } from '@mui/material'
import { COLORS } from 'app-constants'
import useCheckMobileScreen from 'hooks/use-check-mobile-screen'

const PaginationButtons = ({
  count, // the total number of pages
  onPageChange, // callback for when a page changes
  page, // the current page
  threadsPerPage, // the number of threads per page
  onThreadsPerPageChange,
}: {
  count: number
  onPageChange: (page: number) => void
  page: number
  threadsPerPage: number
  onThreadsPerPageChange: (threadsPerPage: number) => void
}) => {
  const isMobile = useCheckMobileScreen()

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
    onPageChange(newPage)
  }

  return (
    <Stack alignItems={isMobile ? 'center' : 'flex-end'}>
      <TablePagination
        component="div"
        onPageChange={handleChangePage}
        count={count}
        page={threadsPerPage >= count ? 0 : page}
        rowsPerPage={threadsPerPage}
        rowsPerPageOptions={[25]}
        sx={{
          '.MuiTablePagination-toolbar': {
            px: 0,
          },
          '.MuiTablePagination-selectLabel': {
            fontSize: '12px',
            fontWeight: 400,
            color: COLORS.GRAY_2,
          },
          '.MuiTablePagination-displayedRows': {
            fontSize: '12px',
            fontWeight: 500,
            color: COLORS.GRAY_2,
            my: 0,
          },
        }}
      />
    </Stack>
  )
}

export default PaginationButtons
